import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import { OverlayTrigger, Placeholder } from 'react-bootstrap';
import { useAgencyCreators } from '../../../shared/hooks/useAgencyCreators';
import { User } from '../../../model/user/User';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { setSelectetInfluencer } from '../../../store/agency/agencySlice';
import { CustomImageHandler } from '../../../shared/components/CustomImageHandler';

const VISIBLE_CREATORS = 4;

const getUserName = (user?: Partial<User>) =>
    user?.displayName || `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();

export function AgencyCreatorHeaderList() {
    const { selectedInfluencer } = useSelector((state: IAllStates) => state.agency);
    const { users, isLoading } = useAgencyCreators();
    const dispatch = useDispatch();

    const selectInfluencer = (user: Partial<User>) => {
        if (selectedInfluencer?.id !== user.id) {
            dispatch(setSelectetInfluencer(user));
        }
    };

    if (isLoading) {
        return (
            <div className="d-flex align-items-center placeholder-glow" aria-hidden="true">
                {Array.from({ length: VISIBLE_CREATORS }).map((_, i) => (
                    <Placeholder key={i} className="skeleton skeleton-agency-header-avatar mr-2" />
                ))}
            </div>
        );
    }

    const visibleUsers = users?.slice(0, VISIBLE_CREATORS) ?? [];
    const isSelectedOutOfList =
        !!selectedInfluencer?.id && visibleUsers.every(user => user.id !== selectedInfluencer?.id);

    return (
        <>
            {visibleUsers.map(item => {
                const isSelected = item?.id === selectedInfluencer?.id;
                const name = getUserName(item);

                return (
                    <div onClick={() => selectInfluencer(item)} key={item.id} className="mr-2 cursor-pointer">
                        <OverlayTrigger
                            overlay={
                                <Tooltip placement="bottom" id={`tooltip-creator-${item.id}`}>
                                    {name}
                                </Tooltip>
                            }
                        >
                            <div
                                className={
                                    isSelected ? 'position-relative user-border rounded-circle' : 'position-relative'
                                }
                            >
                                <CustomImageHandler
                                    photoPath={item?.profilePhoto?.thumbnail}
                                    classes="agency-filter-rounded-img img-cover"
                                    altTag="User Profile"
                                    placeholder="/icons/UserPlaceholder.png"
                                    name={name}
                                />
                                {isSelected && <p className="active-user mb-0">Active</p>}
                            </div>
                        </OverlayTrigger>
                    </div>
                );
            })}

            {isSelectedOutOfList && (
                <div onClick={() => selectInfluencer(selectedInfluencer)} className="mr-2 cursor-pointer">
                    <OverlayTrigger
                        overlay={
                            <Tooltip placement="bottom" id="tooltip-creator-selected">
                                {getUserName(selectedInfluencer)}
                            </Tooltip>
                        }
                    >
                        <div className="position-relative user-border rounded-circle">
                            <CustomImageHandler
                                photoPath={selectedInfluencer?.profilePhoto?.thumbnail}
                                thumbnailPath={selectedInfluencer?.profilePhoto?.thumbnail}
                                classes="agency-filter-rounded-img img-cover"
                                altTag="User Profile"
                                name={getUserName(selectedInfluencer)}
                            />
                            <p className="active-user mb-0">Active</p>
                        </div>
                    </OverlayTrigger>
                </div>
            )}
        </>
    );
}
